var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1605",
    "data-name": "Group 1605",
    transform: "translate(-1596 -1953)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_121",
    "data-name": "Ellipse 121",
    cx: 49,
    cy: 49,
    r: 49,
    transform: "translate(1596 1953)",
    fill: "#e11857"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 39.232,
    transform: "translate(1625.5 2002.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaild);
export default __webpack_public_path__ + "static/media/faild.5e1bfcff82edc50ce38a975271a2dbdc.svg";
export { ForwardRef as ReactComponent };